<div class="dialog-actions">
  <!-- On a contractor-workflow project closing and reopening are workflow actions (see the panel below) -->
  @if (showLegacyStatusControls) {
    <button mat-icon-button [matMenuTriggerFor]="moreActionsMenu" aria-label="More actions">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #moreActionsMenu="matMenu">
      <button mat-menu-item [disabled]="!isIssueClosed || !('create' | able: issue)"
        (click)="reopenIssue(issue)">
        <mat-icon>autorenew</mat-icon>
        <span>Reopen</span>
      </button>
      <button mat-menu-item [disabled]="isIssueClosed || !('close' | able: issue)" (click)="closeIssue(issue)">
        <mat-icon>check_circle_outline</mat-icon>
        <span>Close</span>
      </button>
    </mat-menu>
  }

  @if (dialogOptions.closable) {
    <button [mat-dialog-close]="dialogResult" class="dialog-close" mat-mini-fab aria-label="Close Sidebar"
      >
      <mat-icon title="Close Sidebar">close</mat-icon>
    </button>
  }

  @if (initialized) {
    <button mat-mini-fab (click)="editing = !editing" [disabled]="!editable">
      <mat-icon>edit</mat-icon>
    </button>
  }
</div>

@if (initialized) {
  <div class="content">
    <section class="header">
      <div class="title">{{issue.title}}</div>
      @if (issue.description) {
        <div class="mat-body">{{issue.description}}</div>
      }
      <div class="row footer">
        @if (issue.createdBy) {
          <app-account-inline [account]="issue.createdBy" />
        }
        <div class="mat-caption">{{issue.created_at | dateFormat : 'MMMM DD, YYYY'}}</div>
        <!-- <div class="mat-caption">2 edits</div> -->
      </div>
    </section>
    <!--
      On a contractor-workflow project the panel below brings its own Details /
      Discussion tabs around the form; anywhere else it renders the form as it is.
    -->
    @if (showLegacyStatusControls) {
      <nav mat-tab-nav-bar class="sub-nav">
        <a mat-tab-link active="active">Details</a>
      </nav>
    }
    <app-issue-workflow-panel (issueChanged)="onWorkflowChange($event)" [issue]="issue" [project]="project">
    <form [formGroup]="inputForm">
      <div class="container">
        <!-- title section -->
        @if (editing) {
          <section>
            <mat-form-field>
              <mat-label>Title</mat-label>
              <input matInput type="text" autocomplete="off" formControlName="title" [errorStateMatcher]="matcher" />
              @if (inputForm.controls.title.hasError('required')) {
                <mat-error>
                  This field is <strong>required</strong>
                </mat-error>
              }
              @if (inputForm.controls.title.hasError('error')) {
                <mat-error>
                  {{inputForm.controls.title.errors.error}}
                </mat-error>
              }
            </mat-form-field>
          </section>
        }
        <!-- /title section -->
        <!-- description section -->
        @if (editing) {
          <section>
            <mat-form-field>
              <mat-label>Description</mat-label>
              <textarea matInput formControlName="description" [errorStateMatcher]="matcher"></textarea>
              @if (inputForm.controls.description.hasError('required')) {
                <mat-error>
                  This field is <strong>required</strong>
                </mat-error>
              }
              @if (inputForm.controls.description.hasError('error')) {
                <mat-error>
                  {{inputForm.controls.description.errors.error}}
                </mat-error>
              }
            </mat-form-field>
          </section>
        }
        <!-- /description section -->
        <!-- On a contractor-workflow project the panel above shows the status -->
        @if (!editing && !isWorkflowIssue) {
          <section>
            <div class="mat-body-2 row">Status:</div>
            <div class="mat-body">{{ statusLabel }}</div>
          </section>
        }
        <section>
          @if (!editing) {
            <div class="mat-body-2 row">Scope:</div>
          }
          @if (!editing) {
            <div class="mat-body capitalize">{{issue.entity_type}} {{issue.entity?.name}}</div>
          }
          @if (editing) {
            <mat-form-field>
              <mat-label>SCOPE</mat-label>
              <mat-select formControlName="scope_id" [errorStateMatcher]="matcher">
                @for (scope of scopes; track scope) {
                  <mat-option [value]="scope.id">
                    <div [class.pad]="scope.child">{{scope.name}}</div>
                  </mat-option>
                }
              </mat-select>
              @if (inputForm.controls.scope_id.hasError('required')) {
                <mat-error>
                  This field is <strong>required</strong>
                </mat-error>
              }
              @if (inputForm.controls.scope_id.hasError('error')) {
                <mat-error>
                  {{inputForm.controls.scope_id.errors.error}}
                </mat-error>
              }
            </mat-form-field>
          }
        </section>
        <section>
          <div class="mat-body-2 row">
            <div>Internal:</div>
            <div class="icons">
              <mat-slide-toggle [(ngModel)]="issue.internal" [ngModelOptions]="{standalone: true}" [disabled]="!editing"
                [checked]="issue.internal">
              </mat-slide-toggle>
            </div>
          </div>
        </section>
        <section>
          <div class="mat-body-2 row">Category:</div>
          @if (!editing) {
            <div class="mat-body">{{issueTypeLabel(issue.type)}}</div>
          }
          @if (editing) {
            <mat-radio-group matInput aria-label="Select category" formControlName="type"
              [errorStateMatcher]="matcher">
              @for (issueType of issueTypes; track issueType) {
                <mat-radio-button [value]="issueType.type">
                  {{issueType.label}}
                </mat-radio-button>
              }
            </mat-radio-group>
          }
          @if (inputForm.controls.type.hasError('required')) {
            <mat-error>
              This field is <strong>required</strong>
            </mat-error>
          }
          @if (inputForm.controls.type.hasError('error')) {
            <mat-error>
              {{inputForm.controls.type.errors.error}}
            </mat-error>
          }
        </section>
        <!-- Bid Item section -->
        <section>
          <div class="mat-body-2 row">Bid Item:</div>
          @if (issue.bid_item) {
            <div class="bid-item link" (click)="openBidItemSelector()">
              <div class="title">{{issue.bid_item?.item}}</div>
              <div class="body">{{issue.bid_item?.description}}</div>
            </div>
          }
          @if (!issue.bid_item) {
            <div class="input-placeholder" (click)="openBidItemSelector()">
              <button mat-icon-button [disabled]="!editing" color="accent">
                <mat-icon>add</mat-icon>
              </button>Add bid item
            </div>
          }
        </section>
        <!-- /Bid Item section -->
        <!-- Annotation section -->
        <!--        <section>-->
        <!--          <div class="mat-subheading-1">Annotation:</div>-->
        <!--          <div class="input-placeholder" *ngIf="!issue.annotation" (click)="openAnnot()">-->
        <!--            <button mat-icon-button [disabled]="!editing" color="accent">-->
        <!--              <mat-icon>add</mat-icon>-->
      <!--            </button>Add annotation-->
    <!--          </div>-->
    <!--          <div class="preview-list">-->
    <!--            <div *ngIf="issue.annotation">-->
    <!--              <img class="link" [src]="issue.annotation.getThumbnail()" alt="Annotation Preview"-->
    <!--                (click)="openAnnot(issue.annotation)" />-->
    <!--              <button *ngIf="editing" class="hover-icon" mat-icon-button aria-label="Delete" title="Delete"-->
    <!--                (click)="removeAnnot(issue.annotation)">-->
    <!--                <mat-icon>delete</mat-icon>-->
  <!--              </button>-->
<!--            </div>-->
<!--          </div>-->
<!--        </section>-->
<!-- /Annotation section -->
<!-- location section -->
<section>
  <div class="mat-body-2">Location:</div>
  @if (!issue.latitude || !issue.longitude) {
    <div class="input-placeholder" (click)="editLocation(issue)">
      <button mat-icon-button [disabled]="!editing" color="accent">
        <mat-icon>location_on</mat-icon>
      </button>Add Location
    </div>
  }
  @if (issue.latitude) {
    <div (click)="editLocation(issue)">
      <app-location-picker [isDialog]="false" [latitude]="issue.latitude" [longitude]="issue.longitude"
      height="100px" [readOnly]="true"></app-location-picker>
    </div>
  }
</section>
<!-- /location section -->
<!-- Pictures section -->
<section>
  <div class="mat-body-2">Pictures:</div>
  <div class="preview-list">
    @for (pic of issue.pictures; track pic) {
      <div>
        <img [src]="pic.getThumbnail()" class="link" (click)="appSrv.openCarousel($event, issue.pictures, pic)" />
        @if (editing) {
          <button mat-icon-button aria-label="Delete" title="Delete" class="hover-icon"
            (click)="removePicture(pic)">
            <mat-icon>delete</mat-icon>
          </button>
        }
      </div>
    }
    <app-file-uploader class="file-uploader input-placeholder small"
      [disabled]="!editing" icon="image" accept="image/*"
      (complete)="onUploadComplete($event)">
    </app-file-uploader>
  </div>
</section>
<!-- /Pictures section -->
<!-- Attachments section -->
<section>
  <div class="mat-body-2">Attachments:</div>
  <div class="preview-list">
    @for (att of issue.attachments; track att) {
      <div>
        <img [src]="att.getThumbnail()" class="link"
          (click)="appSrv.openCarousel($event, issue.attachments, att)" />
        @if (editing) {
          <button mat-icon-button aria-label="Delete" title="Delete" class="hover-icon"
            (click)="removeAttachment(att)">
            <mat-icon>delete</mat-icon>
          </button>
        }
      </div>
    }
    <app-file-uploader class="file-uploader input-placeholder small" [disabled]="!editing" icon="attach_file"
      accept="application/pdf" (complete)="onAttachmentUploadComplete($event)">
    </app-file-uploader>
  </div>
</section>
<!-- /Attachments section -->
<!-- Form Actions -->
<section>
  @if (editing) {
    <div class="row">
      <button [disabled]="!(saveAbility | able: issue)" mat-stroked-button color="accent" (click)="saveItem()">
        @if (issue.id) {
          Update
        }
        @if (!issue.id) {
          Create
        }
      </button>
      <button mat-stroked-button (click)="onCancel()">Cancel</button>
    </div>
  }
</section>
<!-- Form Actions -->
</div>
</form>
</app-issue-workflow-panel>
</div>
}
